import React, { useEffect, useState, Suspense, useContext } from 'react';
import { BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { Box, CircularProgress } from '@material-ui/core';

import { AuthContext } from '../context/Auth/AuthContext';
import LoggedInLayout from '../layout';
import ApiDocLayout from '../components/ApiDocLayout';

// Fallback leve ao trocar de rota (lazy load).
const RouteLoadingFallback = () => (
  <Box display="flex" alignItems="center" justifyContent="center" minHeight="200px" width="100%">
    <CircularProgress size={32} />
  </Box>
);
// const Dashboard = React.lazy(() => import('../pages/Painel'));
const Cadastro = React.lazy(() => import('../pages/Cadastro'));
const Login = React.lazy(() => import('../pages/Login'));
const MobileLogin = React.lazy(() => import('../pages/MobileLogin'));
const Canais = React.lazy(() => import('../pages/Canais'));
const ConnectionsCallback = React.lazy(() => import('../pages/ConnectionsCallback'));
const Importacoes = React.lazy(() => import('../pages/Importacoes'));
const SettingsCustom = React.lazy(() => import('../pages/SettingsCustom'));
const SettingsEmpresas = React.lazy(() => import('../pages/SettingsEmpresas'));
const SettingsPlanos = React.lazy(() => import('../pages/SettingsPlanos'));
const SettingsWhitelabel = React.lazy(() => import('../pages/SettingsWhitelabel'));
const Users = React.lazy(() => import('../pages/Users'));
const Contatos = React.lazy(() => import('../pages/Contatos'));
const ChatMoments = React.lazy(() => import('../pages/Moments'));
const Departamentos = React.lazy(() => import('../pages/Departamentos'));
const Etiquetas = React.lazy(() => import('../pages/Etiquetas'));
const DocumentacaoPage = React.lazy(() => import('../pages/Documentacao'));
const ApiClientesPage = React.lazy(() => import('../pages/api-clientes'));
const ApiMensagensPage = React.lazy(() => import('../pages/api-mensagens'));
const ApiContatosPage = React.lazy(() => import('../pages/api-contatos'));
const ApiTagsPage = React.lazy(() => import('../pages/api-tags'));
const ApiProdutosPage = React.lazy(() => import('../pages/api-produtos'));
const ApiServicosPage = React.lazy(() => import('../pages/api-servicos'));
const ApiUsuariosPage = React.lazy(() => import('../pages/api-usuarios'));
const ApiFilasPage = React.lazy(() => import('../pages/api-filas'));
const ApiNegociosPage = React.lazy(() => import('../pages/api-negocios'));
const ApiTagsKanbanPage = React.lazy(() => import('../pages/api-tags-kanban'));
const ApiProjetosPage = React.lazy(() => import('../pages/api-projetos'));
const ApiTarefasPage = React.lazy(() => import('../pages/api-tarefas'));
const ApiTicketsPage = React.lazy(() => import('../pages/api-tickets'));
const ApiConexoesPage = React.lazy(() => import('../pages/api-conexoes'));
const ApiFaturasPage = React.lazy(() => import('../pages/api-faturas'));
const PublicApiDocs = React.lazy(() => import('../pages/PublicApiDocs'));
const PublicDocs = React.lazy(() => import('../pages/PublicDocs'));
const Helps = React.lazy(() => import('../pages/Helps'));
const ContactLists = React.lazy(() => import('../pages/ContactLists'));
const ContactListItems = React.lazy(() => import('../pages/ContactListItems'));
const QuickMessages = React.lazy(() => import('../pages/QuickMessages'));
import { AuthProvider } from '../context/Auth/AuthContext';
import { PlanPermissionsProvider } from '../context/PlanPermissionsContext.jsx';
import { TicketsContextProvider } from '../context/Tickets/TicketsContext.jsx';
import { WhatsAppsProvider } from '../context/WhatsApp/WhatsAppsContext.jsx';
import Route from './Route.jsx';
const Schedules = React.lazy(() => import('../pages/Lembretes'));
const Campanhas = React.lazy(() => import('../pages/Campanhas'));
const CampaignsConfig = React.lazy(() => import('../pages/CampaignsConfig'));
const FlowUp = React.lazy(() => import('../pages/Marketing/FlowUp'));
const CampaignReport = React.lazy(() => import('../pages/CampaignReport'));
const Annoucements = React.lazy(() => import('../pages/Annoucements'));
const Faturas = React.lazy(() => import('../pages/Faturas'));
const Chat = React.lazy(() => import('../pages/Chat'));
const Agentes = React.lazy(() => import('../pages/Agentes'));
const ForgetPassword = React.lazy(() => import('../pages/ForgetPassWord/'));
const AllConnections = React.lazy(() => import('../pages/AllConnections'));
const Reports = React.lazy(() => import('../pages/Reports'));
const FlowBuilderConfig = React.lazy(() =>
  import('../pages/FlowBuilderConfig').then((m) => ({ default: m.FlowBuilderConfig }))
);
const FlowBuilder = React.lazy(() => import('../pages/FlowBuilder'));
const CampaignsPhrase = React.lazy(() => import('../pages/CampaignsPhrase'));
const Subscription = React.lazy(() => import('../pages/Subscription'));
const QueueIntegration = React.lazy(() => import('../pages/Integracao'));
const Files = React.lazy(() => import('../pages/Files'));
const Produtos = React.lazy(() => import('../pages/Produtos'));
const Kanban = React.lazy(() => import('../pages/Kanban'));
const TagsKanban = React.lazy(() => import('../pages/TagsKanban'));
const empresa = React.lazy(() => import('../pages/Empresa'));
const IaWorkflows = React.lazy(() => import('../pages/IaWorkflows'));
const IaWorkflowEditor = React.lazy(() => import('../pages/IaWorkflowEditor'));
const TutorialVideos = React.lazy(() => import('../pages/TutorialVideos'));
const SliderBannersPage = React.lazy(() => import('../pages/SliderBanners'));
const ServicosPage = React.lazy(() => import('../pages/Servicos'));
const ProfissionaisPage = React.lazy(() => import('../pages/Profissionais'));
const Automations = React.lazy(() => import('../pages/Automations'));
const Sistema = React.lazy(() => import('../pages/Sistema'));
const PaymentCredentialsPage = React.lazy(() => import('../pages/PaymentCredentials'));
const FaturamentoPage = React.lazy(() => import('../pages/Faturamento'));
const FinanceiroSuperAdmin = React.lazy(() => import('../pages/FinanceiroSuperAdmin'));
const IntegrationSettings = React.lazy(() => import('../pages/IntegrationSettings'));
const FerramentasPage = React.lazy(() => import('../pages/Ferramentas'));
const ContactSettings = React.lazy(() => import('../pages/ContactSettings'));
const ContactAnalytics = React.lazy(() => import('../pages/ContactAnalytics'));
const Leads = React.lazy(() => import('../pages/Leads'));
const Clients = React.lazy(() => import('../pages/Clientes'));
const ClientDetails = React.lazy(() => import('../pages/ClientDetails'));
const Projects = React.lazy(() => import('../pages/Projects'));
const ProjectDetails = React.lazy(() => import('../pages/ProjectDetails'));
const UserSchedules = React.lazy(() => import('../pages/UserSchedules'));
const Agenda = React.lazy(() => import('../pages/Agenda'));
const AppsPage = React.lazy(() => import('../pages/Apps'));
const SuperAdminAppsPage = React.lazy(() => import('../pages/SuperAdminApps'));
const ContaBloqueada = React.lazy(() => import('../pages/ContaBloqueada'));
const PlanosPage = React.lazy(() => import('../pages/Planos'));
const PlanosDetalhes = React.lazy(() => import('../pages/Planos/Detalhes'));

const Funil = React.lazy(() => import('../pages/Funil'));
const FeatureDetailPage = React.lazy(() => import('../pages/landingpage/FeatureDetailPage'));
const TermsOfService = React.lazy(() => import('../pages/landingpage/TermsOfService'));
const UsagePolicy = React.lazy(() => import('../pages/landingpage/UsagePolicy'));
const PrivacyPolicy = React.lazy(() => import('../pages/landingpage/PrivacyPolicy'));
const PublicCheckout = React.lazy(() => import('../pages/PublicCheckout'));
const Atendimentos = React.lazy(() => import('../pages/Atendimentos'));
import { QueueSelectedProvider } from '../context/QueuesSelected/QueuesSelectedContext.jsx';
import NotificationToast from '../components/NotificationToast/index.jsx';

/** Notificação de nova mensagem do contato: global quando logado (igual ideia do toast do sistema). */
const NotificationToastGlobal = () => {
  const { isAuth, loading } = useContext(AuthContext);
  if (loading || !isAuth) return null;
  return <NotificationToast />;
};

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem('cshow');
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <PlanPermissionsProvider>
          <NotificationToastGlobal />
          <TicketsContextProvider>
            <Suspense fallback={<RouteLoadingFallback />}>
              <Switch>
                <Route exact path="/" component={Login} isPublic />
                <Route exact path="/login" component={Login} isPublic />
                <Route exact path="/solucoes/:slug" component={FeatureDetailPage} isPublic />
                <Route exact path="/docs/public/api" component={PublicApiDocs} isPublic />
                <Route path="/docs" component={PublicDocs} isPublic />
                <Route exact path="/terms-of-service" component={TermsOfService} isPublic />
                <Route exact path="/usage-policy" component={UsagePolicy} isPublic />
                <Route exact path="/privacy-policy" component={PrivacyPolicy} isPublic />
                <Route exact path="/mobile-login" component={MobileLogin} isPublic />
                <Route exact path="/signup" component={Cadastro} isPublic />
                <Route exact path="/forgetpsw" component={ForgetPassword} isPublic />
                <Route exact path="/checkout/:token" component={PublicCheckout} isPublic />
                <Route exact path="/public/checkout/:token" component={PublicCheckout} isPublic />
                <Route exact path="/integrations/meta" component={ConnectionsCallback} isPublic />
                <WhatsAppsProvider>
                  <QueueSelectedProvider>
                    <LoggedInLayout>
                      <Switch>
                        <Route exact path="/dashboard" component={Reports} isPrivate />
                        <Route exact path="/tickets/channels" component={Canais} isPrivate />
                        <Route exact path="/tickets/imports" component={Importacoes} isPrivate />
                        <Route
                          exact
                          path="/tickets/quick-messages"
                          component={QuickMessages}
                          isPrivate
                        />
                        <Route exact path="/tickets/queues" component={Departamentos} isPrivate />
                        <Route exact path="/tickets/tags" component={Etiquetas} isPrivate />
                        <Route exact path="/tickets/schedules" component={Schedules} isPrivate />
                        <Route
                          exact
                          path="/schedules"
                          isPrivate
                          render={() => <Redirect to="/tickets/schedules" />}
                        />
                        <Route
                          exact
                          path="/tickets/conversation/:ticketId?"
                          component={Atendimentos}
                          isPrivate
                        />
                        <Route exact path="/todolist" component={Produtos} isPrivate />
                        <Route exact path="/sales/products" component={Produtos} isPrivate />
                        <Route
                          exact
                          path="/contacts/import-contacts"
                          component={Contatos}
                          isPrivate
                        />
                        <Route exact path="/helps" component={Helps} isPrivate />
                        <Route exact path="/system/users" component={Users} isPrivate />
                        <Route exact path="/messages-api" component={DocumentacaoPage} isPrivate />
                        <Route
                          exact
                          path="/messages-api/documentacao"
                          render={() => (
                            <ApiDocLayout title="API de clientes">
                              <ApiClientesPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-mensagens"
                          render={() => (
                            <ApiDocLayout title="API de mensagens">
                              <ApiMensagensPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-contatos"
                          render={() => (
                            <ApiDocLayout title="API de contatos">
                              <ApiContatosPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-tags"
                          render={() => (
                            <ApiDocLayout title="API de tags">
                              <ApiTagsPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-produtos"
                          render={() => (
                            <ApiDocLayout title="API de produtos">
                              <ApiProdutosPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-servicos"
                          render={() => (
                            <ApiDocLayout title="API de serviços">
                              <ApiServicosPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-usuarios"
                          render={() => (
                            <ApiDocLayout title="API de usuários">
                              <ApiUsuariosPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-filas"
                          render={() => (
                            <ApiDocLayout title="API de filas">
                              <ApiFilasPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-negocios"
                          render={() => (
                            <ApiDocLayout title="API de negócios">
                              <ApiNegociosPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-tags-kanban"
                          render={() => (
                            <ApiDocLayout title="API de tags kanban">
                              <ApiTagsKanbanPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-projetos"
                          render={() => (
                            <ApiDocLayout title="API de projetos">
                              <ApiProjetosPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-tarefas"
                          render={() => (
                            <ApiDocLayout title="API de tarefas">
                              <ApiTarefasPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-tickets"
                          render={() => (
                            <ApiDocLayout title="API de tickets">
                              <ApiTicketsPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-conexoes"
                          render={() => (
                            <ApiDocLayout title="API de conexões WhatsApp">
                              <ApiConexoesPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/api-faturas"
                          render={() => (
                            <ApiDocLayout title="API de faturas">
                              <ApiFaturasPage />
                            </ApiDocLayout>
                          )}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/super-admin/settings"
                          component={SettingsCustom}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/super-admin/whitelabel"
                          component={SettingsWhitelabel}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/super-admin/companies"
                          component={SettingsEmpresas}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/super-admin/plans"
                          component={SettingsPlanos}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/super-admin/payment-credentials"
                          component={PaymentCredentialsPage}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/super-admin/invoices"
                          component={FaturamentoPage}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/super-admin/financial"
                          component={FinanceiroSuperAdmin}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/super-admin/apps"
                          component={SuperAdminAppsPage}
                          isPrivate
                        />
                        <Route exact path="/system/:categorySlug?" component={Sistema} isPrivate />
                        <Route exact path="/tools" component={FerramentasPage} isPrivate />
                        <Route
                          exact
                          path="/queue-integration"
                          component={QueueIntegration}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/automations/integration"
                          component={QueueIntegration}
                          isPrivate
                        />
                        <Route exact path="/announcements" component={Annoucements} isPrivate />
                        <Route exact path="/subscription/invoice" component={Faturas} isPrivate />
                        <Route exact path="/documentation" component={Funil} isPrivate />
                        <Route exact path="/editkanban" component={Funil} isPrivate />
                        <Route exact path="/company" component={empresa} isPrivate />
                        <Route
                          exact
                          path="/automations/integration/integration-settings"
                          component={IntegrationSettings}
                          isPrivate
                        />

                        <Route
                          exact
                          path="/marketing/campaign-by-phrase"
                          component={CampaignsPhrase}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/automations/flowbuilders"
                          component={FlowBuilder}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/automations/flowbuilder/:id?"
                          component={FlowBuilderConfig}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/chats/:id?"
                          component={Chat}
                          isPrivate
                          allowedProfiles={['admin', 'superadmin']}
                        />
                        <Route exact path="/files" component={Files} isPrivate />
                        <Route exact path="/moments" component={ChatMoments} isPrivate />
                        <Route exact path="/Kanban" component={Kanban} isPrivate />
                        <Route exact path="/TagsKanban" component={TagsKanban} isPrivate />
                        <Route exact path="/prompts" component={Agentes} isPrivate />
                        <Route exact path="/automations/agents" component={Agentes} isPrivate />
                        <Route
                          exact
                          path="/automations/ia-workflows"
                          component={IaWorkflows}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/automations/ia-workflows/:id"
                          component={IaWorkflowEditor}
                          isPrivate
                        />
                        <Route exact path="/tutorial-videos" component={TutorialVideos} isPrivate />
                        <Route
                          exact
                          path="/slider-banners"
                          component={SliderBannersPage}
                          isPrivate
                        />
                        <Route exact path="/sales/services" component={ServicosPage} isPrivate />
                        <Route
                          exact
                          path="/profissionais"
                          component={ProfissionaisPage}
                          isPrivate
                        />
                        <Route exact path="/contacts/leads" component={Leads} isPrivate />
                        <Route exact path="/sales/clients" component={Clients} isPrivate />
                        <Route
                          exact
                          path="/contatos/import-clientes/:clientId"
                          component={ClientDetails}
                          isPrivate
                        />
                        <Route exact path="/projects" component={Projects} isPrivate />
                        <Route
                          exact
                          path="/projects/:projectId"
                          component={ProjectDetails}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/system/users/user-schedules"
                          component={UserSchedules}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/system/users/appointments"
                          component={Agenda}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/automations/message"
                          component={Automations}
                          isPrivate
                        />
                        <Route exact path="/allConnections" component={AllConnections} isPrivate />
                        <Route exact path="/subscription" component={Subscription} isPrivate />
                        <Route exact path="/apps" component={AppsPage} isPrivate />
                        <Route
                          exact
                          path="/subscription/plans/details"
                          component={PlanosDetalhes}
                          isPrivate
                        />
                        <Route exact path="/subscription/plans" component={PlanosPage} isPrivate />
                        <Route exact path="/account-blocked" component={ContaBloqueada} isPrivate />
                        <Route
                          exact
                          path="/contacts/settings"
                          component={ContactSettings}
                          isPrivate
                        />
                        <Route
                          exact
                          path="/contact-analytics"
                          component={ContactAnalytics}
                          isPrivate
                        />
                        <Route exact path="/marketing/flowup" component={FlowUp} isPrivate />
                        <Route
                          exact
                          path="/marketing/mass-shooting"
                          component={Campanhas}
                          isPrivate
                        />
                        {showCampaigns && (
                          <>
                            <Route
                              exact
                              path="/contacts/contact-lists"
                              component={ContactLists}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/contacts/contact-lists/:contactListId/contacts"
                              component={ContactListItems}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/marketing/mass-shooting/:campaignId/report"
                              component={CampaignReport}
                              isPrivate
                            />
                            <Route
                              exact
                              path="/marketing/campaigns-config"
                              component={CampaignsConfig}
                              isPrivate
                            />
                          </>
                        )}
                      </Switch>
                    </LoggedInLayout>
                  </QueueSelectedProvider>
                </WhatsAppsProvider>
              </Switch>
            </Suspense>
          </TicketsContextProvider>
        </PlanPermissionsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
